import { AreaChart } from '@/components/charts/AreaChart';
import { RiskSeverityCard } from '@/sections/insights/metrics/components/RiskSeverityCard';
import { getRandom } from '@/sections/insights/metrics/utils/dateUtils';
import { RiskSeverity } from '@/types';

function BaseComponent({
  data,
}: {
  data: Record<
    'critical' | 'high' | 'medium' | 'low' | 'info',
    {
      name: string;
      count: number;
    }[]
  >;
}) {
  return (
    <div className="flex size-full flex-col gap-4">
      <Card severity={RiskSeverity.Critical} points={data.critical} />
      <Card severity={RiskSeverity.High} points={data.high} />
      <Card severity={RiskSeverity.Medium} points={data.medium} />
      <Card severity={RiskSeverity.Low} points={data.low} />
      <Card severity={RiskSeverity.Info} points={data.info} />
    </div>
  );
}

const sampleData = [...Array(30).keys()].reduce(
  (acc, i) => {
    return {
      critical: [
        ...(acc.critical || []),
        { name: `Jan ${i + 1}`, count: getRandom() },
      ],
      high: [...(acc.high || []), { name: `Jan ${i + 1}`, count: getRandom() }],
      medium: [
        ...(acc.medium || []),
        { name: `Jan ${i + 1}`, count: getRandom() },
      ],
      low: [...(acc.low || []), { name: `Jan ${i + 1}`, count: getRandom() }],
      info: [...(acc.info || []), { name: `Jan ${i + 1}`, count: getRandom() }],
    };
  },
  {} as Record<
    'critical' | 'high' | 'medium' | 'low' | 'info',
    { name: string; count: number }[]
  >
);

export function VulnerabilityAnalysisExample() {
  return <BaseComponent data={sampleData} />;
}

interface CardProps {
  severity: RiskSeverity;
  points: { name: string; count: number }[];
}

function Card({ points, severity }: CardProps) {
  const lastPoint = points[points.length - 1];

  return (
    <div className="bg-chariot-background-secondary flex h-[28px] overflow-hidden rounded-3xl">
      <div className="w-full overflow-hidden">
        <AreaChart data={points} />
      </div>
      <RiskSeverityCard
        label={lastPoint.count.toString()}
        severity={severity}
        labelClassName="w-[50px]"
      />
    </div>
  );
}
